import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
export function forbiddenStringValidator(arrValue: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        let forbidden = false;
        if (control.value && arrValue.includes(control.value.toLowerCase().trim())) {
            forbidden = true;
        }
        return forbidden ? { forbiddenString: { value: control.value } } : null;
    };
}